import { Alchemy, TokenBalance } from 'alchemy-sdk'
import { Chain, createPublicClient, http } from 'viem'

import { ERC20 } from 'abis/ERC20'
import { Hash, OwnedToken } from 'types/entities'

import { convert } from 'utils/helpers'
import { isEther, toChecksumAddress } from 'utils/crypto'

import { CHAIN_INFO } from 'constants/chains'
import { ETH_ADDRESS } from 'constants/addresses'

const ALCHEMY_KEY = 'Cb_eX45UFOFyQcDuylZ1EX-XbNoz8VvH'

async function metadataMulticall(tokens: TokenBalance[], chain: Chain) {
  const client = createPublicClient({ chain, transport: http() })

  const multicallParams = tokens
    .map((_token) => {
      const contract = { address: _token.contractAddress, abi: ERC20 } as const

      return [
        { ...contract, functionName: 'name' },
        { ...contract, functionName: 'symbol' },
        { ...contract, functionName: 'decimals' },
      ]
    })
    .flat()

  // @ts-ignore
  const result = await client.multicall({ contracts: multicallParams })

  const chunks = []
  for (let i = 0; i < result.length; i = i + 3) {
    chunks.push(result.slice(i, i + 3))
  }

  return chunks.map(([name, symbol, decimals], index) => {
    const address = toChecksumAddress(tokens[index].contractAddress)
    if (isEther(address)) {
      return {
        address,
        name: chain.nativeCurrency.name,
        symbol: chain.nativeCurrency.symbol,
        balance: tokens[index].tokenBalance,
        decimals: chain.nativeCurrency.decimals,
      }
    }
    return {
      name: name.result as string,
      symbol: symbol.result as string,
      balance: tokens[index].tokenBalance,
      decimals: decimals.result ? Number(decimals.result) : 0,
      address: toChecksumAddress(tokens[index].contractAddress),
    }
  })
}

export async function alchemy(_address: Hash, chain: Chain) {
  const client = new Alchemy({
    apiKey: ALCHEMY_KEY,
    network: CHAIN_INFO[chain.id].id,
  })
  const balances = await client.core.getTokenBalances(_address)

  const eth_balance = await client.core.getBalance(_address)

  balances.tokenBalances.push({
    contractAddress: ETH_ADDRESS,
    tokenBalance: eth_balance._hex,
    error: null,
  })

  const _data = await metadataMulticall(balances.tokenBalances, chain)

  return _data.reduce<OwnedToken[]>((acc, curr) => {
    if (!curr?.symbol) {
      return acc
    }
    const token = convert({
      name: curr.name,
      symbol: curr.symbol,
      address: curr.address,
      decimals: curr.decimals,
      balance: curr.balance || '0',
    })
    return acc.concat(token)
  }, [])
}
